<template>
  <b-modal
    id="payoutOptionModal"
    title="Select Preferred Payout Option"
    :headerClass="`add-vello-icon`"
    centered
    hide-footer
  >
    <div class="mx-3">
      <div class="custom-control custom-radio b-custom-control-lg pt-2">
        <input
          type="radio"
          id="payoutOptionAuto"
          class="custom-control-input"
          v-model="option"
          value="automatic"
        />
        <label class="custom-control-label pb-2" for="payoutOptionAuto">
          Automatic Weekly Payouts
        </label>
        <p class="font-sm-2">
          A Stripe account will be created for you and user payments are
          INSTANTLY added to your Stripe account (Requires SSN for ID
          verification).
        </p>
        <p class="font-sm-2">
          Earnings will be transferred from your Stripe account to your
          nominated bank account. Weekly.
        </p>
        <p class="font-sm-2">
          All details you provide in this form are submitted securely with
          STRIPE featuring best-in-class security tools and practices.
        </p>
        <p class="font-sm-2">
          Vello does not store records of information submitted via the Stripe
          form.
        </p>
        <b-img
          src="~@/assets/img/stripe-payment.png"
          class="d-inline-block"
          height="40px"
        />
      </div>

      <div class="custom-control custom-radio b-custom-control-lg pt-4">
        <input
          type="radio"
          id="payoutOptionManual"
          class="custom-control-input"
          v-model="option"
          value="manual"
        />
        <label class="custom-control-label pb-2" for="payoutOptionManual">
          Monthly Payouts
        </label>
        <p class="font-sm-2">
          Vello will accept payments on your behalf and transfer your earnings
          to your nominated bank account on a monthly basis.
        </p>
      </div>
    </div>

    <b-button
      class="radius-30 w-100 mt-4"
      variant="primary"
      @click="$emit('continue', option)"
    >
      Continue
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'PayoutOptionModal',
  props: ['selected'],
  data() {
    return {
      option: null,
    }
  },
  created() {
    this.option = this.selected
  },
}
</script>

<style lang="scss">
.font-sm-2 {
  font-size: 12px;
  line-height: 20px;
}
</style>
